<template>
  <div class="content-wrapper">
    <h2 class="impact-light plan-count">Plans: <strong>{{ plans.length + memberPlans.length }}</strong></h2>

    <section class="cta-wrapper">
      <Plan v-for="plan in plans" v-bind:key="plan.id" v-bind:plan="plan" v-bind:systemAdmin="(user.userType === 1) ? true : false"/>
      <Plan v-for="memberPlan in memberPlans" v-bind:key="memberPlan.id" v-bind:plan="memberPlan" v-bind:memberPlan="true"/>
    </section>

    <section class="star-info">
      <h2 class="impact-light star-count">{{ $t("plans.plansHome.starredProjects") }}: <strong>{{ stars.length }}</strong></h2>
      <Loader v-if="!starsLoaded"/>
      <Star v-if="starsLoaded" v-bind:key="index" v-bind:stars="stars" />
    </section>

  </div>
</template>

<script>
import Plan from '@/components/plans/PlanBlock.vue'
import Star from '@/components/plans/StarBlock.vue'
import Loader from '@/components/Loader.vue'

import { adminService } from '@/services/admin.service'
import { planService } from '@/services/plan.service'
import { groupService } from '@/services/group.service'
import { userService } from '@/services/user.service'

export default {
  name: 'Plans',
  components: {
    Plan,
    Star,
    Loader
  },
  data () {
    return {
      user: {},
      plans: [],
      memberPlans: [],
      stars: [],
      starsLoaded: false,
    }
  },
  mounted: function () {
    // grab the user
    let user = JSON.parse(localStorage.getItem('user'))
    this.user = user.userInfo

    // Site Admin...
    if(user.userInfo.userType === 1) {
      adminService.planSearch('').then((plans) => {
        this.parseAdminPlans(plans)
        this.$forceUpdate()
      })
    }
    // everyone else.
    else {
      // grab my plans
      planService.myPlans().then(plans => {
        this.parseAdminPlans(plans)

        // grab my groups
        groupService.getGroups().then(groups => {
          this.parseMemberPlans(groups)
          this.$forceUpdate()
        })
        this.$forceUpdate()
      })
    }

    this.getStars()
  },
  methods: {
    // Somehow getting duplicates in admin plan results, so dedup them.
    parseAdminPlans: function (plans) {
      for(let plan of plans) {
        if(this.plans.map((p) => { return p.id }).indexOf(plan.id) === -1
          && plan.enabled) {
          if(plan.description){
            plan.description = decodeURIComponent(atob(plan.description))
          }
          this.plans.push(plan)
        }
      }
    },
    // Pull out planId's and planNames from my group list.
    parseMemberPlans: function (groups) {
      for(let group of groups) {
        this.parseMemberPlan(group)
      }
    },
    parseMemberPlan: function(group){
      planService.getPlanByMember(group.planId).then(plan => {
        let memberPlan = {}
        memberPlan = {
          id: group.planId,
          name: group.planName,
          planEnabled: plan.enabled
        }

        // Duplicate checking
        if(this.plans.map((p) => { return p.id }).indexOf(memberPlan.id) === -1
          && this.memberPlans.map((n) => { return n.id }).indexOf(memberPlan.id) === -1
          && plan.enabled) {
          this.memberPlans.push(memberPlan)
        }
      }).catch((err) => {
        console.error('Something went wrong fetching plan: ', err)
      })
    },
    getStars: function () {
      userService.getStars().then(stars => {
        //console.log(stars)
        this.stars = stars
        this.starsLoaded = true
      }).catch(err => {
        console.error('Unable to get stars: ', err)
      })
    }
  }
}
</script>

<style lang="scss">
.star-info {
  margin: -80px 0 92px;
}
</style>
